var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ListingLayout',{attrs:{"is-loading":_vm.isLoading,"meta":_vm.meta,"headers":_vm._headers,"items":_vm.list,"filter-names":_vm.filterNames,"search-label":"search"},on:{"filterOption":_vm.onFiltersChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }